import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  selectHeaderImagen,
  selectTemplateImage,
} from 'legacyfrontend/redux/selectors/application-selectors';
import LoadSpinner from 'legacyfrontend/components/spinner';
import useSearcherValidation from 'legacyfrontend/hooks/useSearcherValidation';

const BillboardImage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const mountedRef = useRef(true);
  const imageLoadedRef = useRef(false);
  const headerImagen = useSelector(selectHeaderImagen);
  const templateImage = useSelector(selectTemplateImage);
  const { isSearchRoute } = useSearcherValidation();
  const finalImageSrc = headerImagen || templateImage;

  const handleImageLoad = useCallback(() => {
    if (!mountedRef.current) return;
    imageLoadedRef.current = true;
    setIsLoading(false);
  }, []);

  const handleImageError = useCallback(() => {
    if (!mountedRef.current) return;
    setIsLoading(false);
  }, []);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (!mountedRef.current) return;
    if (finalImageSrc && !imageLoadedRef.current) {
      setIsLoading(true);
    }
  }, [finalImageSrc]);

  return (
    <div
      className={`w-full relative overflow-hidden max-h-[35vh] md:max-h-[42vh] min-h-[380px]`}
    >
      {isLoading && (
        <div className='w-full h-full flex justify-center items-center bg-gray-100'>
          <LoadSpinner />
        </div>
      )}
      <img
        alt='Billboard background'
        className={`w-full h-[35vh] md:h-[50vh] min-h-[380px] object-cover object-center md:object-top ${isLoading ? 'hidden' : 'block'}`}
        onError={handleImageError}
        onLoad={handleImageLoad}
        src={finalImageSrc}
      />
    </div>
  );
};

export default BillboardImage;
